import Table, { PrimaryKeyValues } from "table/Table";
import MultipleQueryColumn from "./MultipleQueryColumn";
import { Fetcher } from "./Fetch";
import { Row } from "table/Row";
import { LoadableQuery } from "./SkeletalQuery";



export default class Query extends MultipleQueryColumn implements LoadableQuery {
    public id : PrimaryKeyValues|null = null;

    constructor(t: Table) {
        super(t, t.columns, undefined);
        this.name = t.name;
        this._isExpanded = true;
    }

    removeAllColumns = () => {
        this._select = []; // TODO delete me new MultipleQueryColumn(this, new TableColumn("Parent column", ColumnType.String));
        return this;
    }

    public expandChild = (column: MultipleQueryColumn) => {
        column.expand();
        this.changed();
        return this;
    }

    public unexpandChild = (column: MultipleQueryColumn) => {
        column.unexpand();
        this.changed();
        return this;
    }

    expandByName = (columnName: string) => {
        let column = this.findColumnByPath(columnName);
        if (undefined !== column && column.canHaveChildren()) {
            this.expandChild(column as MultipleQueryColumn);
        } else {
            throw new Error(`No such column ${columnName}`);
        }
    }

    getCount = (fetcher:Fetcher ) => {
        return this._table.fetchCount(fetcher, this);
    }
    
    /* Retrieve table contents for the given row range. */
    fetch(fetcher: Fetcher, from: number, to: number): Promise<Row[]> {
        return this._table.fetch(fetcher, this, from, to);
    }

    /* TODO 
    fetchAndDo(fetcher: Fetcher, doEach: (Row -> void))
    */

    commit = () => {
        console.warn("TODO");
    }

    /* Re-number the columns and populate this.columnNumber */
    renumberColumns = () => { this.renumberColumnsImpl([0]); }

    isLoaded = () => {return true}
    getId = () => {return this.id}
    getName = () => {return this.name}
    getKey = () => {return "transient/"+this.name}

   
}